import { queryOptions } from '@tanstack/react-query';
import { ClanInvite, ClanMember, ClansResponse } from '../../types/clans';
import { apiQueryFn } from '../utils';
import { ApiError } from '~/components/Providers/APIClient';
import { clansParamsType } from '~/routes/_authenticated/staff/clans/-SearchParams';

export const clansQuery = ({ page, per_page, name_filter }: clansParamsType) =>
    queryOptions<ClansResponse, ApiError>({
        queryKey: ['clans', page, per_page, name_filter],
        queryFn: apiQueryFn<ClansResponse>({
            path: `/clans`,
            query: {
                page: page,
                per_page: per_page,
                name_filter: name_filter ? `%${name_filter}%` : undefined,
            },
        }),
    });

export type clanMembersQueryType = {
    clanid: string;
};
export const clanMembersQuery = ({ clanid }: clanMembersQueryType) =>
    queryOptions<ClanMember[], ApiError>({
        queryKey: ['clan', clanid, 'members'],
        queryFn: async (): Promise<ClanMember[]> => {
            const members = await apiQueryFn<ClanMember[]>({
                path: `/clans/${clanid}/members`,
            })();
            return members.sort((a, b) => b.role - a.role);
        },
    });

export const clanInvitesQuery = () =>
    queryOptions<ClanInvite[], ApiError>({
        queryKey: ['clan', 'invites'],
        queryFn: apiQueryFn<ClanInvite[]>({
            path: `/users/@me/clan/invites`,
            attachAuth: true,
        }),
    });
